import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  mapToModel,
  mapToModelArray,
} from '@kinet-open-network/client/shared/data-access/model';
import {
  IBankAccount,
  IOpenBankingStatus,
} from '@kinet-open-network/shared/data-access/model';
import { plainToInstance } from 'class-transformer';
import { format } from 'date-fns';
import { map } from 'rxjs';
import { BankAccount } from '../models/bank-account.model';
import { OpenBankingAccount } from '../models/open-banking-account.model';
import { OpenBankingStatus } from '../models/open-banking-status.model';

@Injectable({
  providedIn: 'root',
})
export class BanksService {
  readonly #http = inject(HttpClient);

  getAccounts() {
    return this.#http
      .get<IBankAccount[]>('/invoicing/banks/accounts')
      .pipe(mapToModelArray(BankAccount));
  }

  setDefaultBankAccount(id: string) {
    return this.#http
      .post<IBankAccount>(`/invoicing/banks/accounts/${id}/default`, {})
      .pipe(mapToModel(BankAccount));
  }

  initOpenBanking() {
    return this.#http.post<{ url: string }>(
      '/invoicing/banks/openbanking/auth/initiate',
      {},
    );
  }

  getOpenBankingStatus() {
    return this.#http
      .get<IOpenBankingStatus>('/invoicing/banks/openbanking/status')
      .pipe(map((status) => plainToInstance(OpenBankingStatus, status)));
  }

  getOpenBankingAccounts() {
    return this.#http
      .get<OpenBankingAccount[]>('/invoicing/banks/openbanking/accounts')
      .pipe(map((accounts) => plainToInstance(OpenBankingAccount, accounts)));
  }

  changeOpenBankingAccounts(openBankingAccountIds: string[]) {
    return this.#http.post<void>('/invoicing/banks/openbanking/accounts', {
      accountIds: openBankingAccountIds,
    });
  }

  synchronizeOpenBankingTransactions(
    openBankingAccountId: string,
    dateFrom: Date,
    dateTo?: Date | null,
  ) {
    return this.#http.post<void>(
      `/invoicing/banks/openbanking/transactions/synchronize`,
      {
        accountId: openBankingAccountId,
        dateFrom: format(dateFrom, 'yyyy-MM-dd'),
        dateTo: dateTo ? format(dateTo, 'yyyy-MM-dd') : undefined,
      },
    );
  }
}
